const STORAGE_KEY = 'credito:journey';

/**
 * Guarda o estado da jornada em sessionStorage. A assinatura sai do app (navegação top-level
 * para a UY3/Unico, que precisa de câmera e geolocalização em contexto próprio) e o retorno
 * pelo botão voltar recarrega a página: sem isso a pessoa perde a proposta em andamento.
 * Escopo de aba, some ao fechar.
 *
 * Escopo deliberadamente restrito a este store, em vez de um plugin global de Pinia: o resto
 * do portal não deve começar a persistir estado como efeito colateral desta feature.
 */
export function loadJourneySnapshot<T>(): Partial<T> | null {
  try {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    return saved ? (JSON.parse(saved) as Partial<T>) : null;
  } catch {
    return null;
  }
}

export function saveJourneySnapshot(snapshot: unknown): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch {
    // sessionStorage indisponível (modo privado, cota): a jornada segue sem persistência.
  }
}

export function clearJourneySnapshot(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
}
